export var BitSwitchOperation;
(function (BitSwitchOperation) {
    BitSwitchOperation[BitSwitchOperation["On"] = 0] = "On";
    BitSwitchOperation[BitSwitchOperation["Off"] = 1] = "Off";
    BitSwitchOperation[BitSwitchOperation["Inverse"] = 2] = "Inverse";
})(BitSwitchOperation || (BitSwitchOperation = {}));
